import React from "react";
import { Table, TableBody, TableRow, TableRowColumn } from "material-ui";
import { FormattedMessage } from "react-intl";
import { tdStyle } from "../../components/Questionnaire/QuestionnaireTable";
import * as moment from 'moment';
import ActionSearch from "material-ui/svg-icons/action/search";
import { checkJapanese } from "../../lib";

export function getProblemTypeTranslation(type) {
  if(!checkJapanese() || !type) {
    return type;
  }

  const problemTypes = {
    joinpage: "入室画面",
    audio: "音声",
    video: "映像",
    screensharing: "画面共有",
    youtubesharing: "YouTube共有",
    chat: "チャット",
    recording: "録画",
    other: "その他",
  }
  return problemTypes[type.toLowerCase().replace(/ /g,'')] || type;
}
class ProblemReportsTable extends React.Component {
  goToDetails = (report) => {
    this.props.history.push({
      pathname: "/fvdomain/problem-reports-details",
      state: { report },
    });
  }

  render() {
    return (
      <div
        style={{
          height: "70vh",
          overflowX: "hidden",
          overflowY: "auto",
          marginTop: "10px",
        }}
      >
        <Table
          selectable={false}
          selectedColor="black"
          bodyStyle={{
            display: "contents",
          }}
          style={{ border: "1px solid #b8b8b8", minWidth: "612px" }}
        >
          <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
            <TableRow
              style={{
                border: "1px solid #b8b8b8",
                backgroundColor: "#6B7c93",
                color: "#fff",
              }}
            >
              <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="problemReport.domainName" />}
              </TableRowColumn>
              <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="problemReport.date" />}
              </TableRowColumn>
              <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="problemReport.problemType" />}
              </TableRowColumn>
              <TableRowColumn style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="problemReport.details" />}
              </TableRowColumn>
            </TableRow>

            {this.props.isFetching ||
              (this.props.reports.length === 0 && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={7} style={tdStyle}>
                    {this.props.isFetching ? (
                      <FormattedMessage id="problemReport.fetchingReport" />
                    ) : (
                      <FormattedMessage id="problemReport.noReport" />
                    )}
                  </TableRowColumn>
                </TableRow>
              ))}

            {this.props.reports.map((report, index) => {
              return (
                <TableRow
                  key={index}
                  selected={false}
                  className={index % 2 == 0 ? "dark-row" : "light-row"}
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={2} style={tdStyle}>
                    {report.room}
                  </TableRowColumn>
                  <TableRowColumn colSpan={2} style={tdStyle}>
                    {moment(report.created_at).format('YYYY-MM-DD HH:mm:ss')}
                  </TableRowColumn>
                  <TableRowColumn colSpan={2} style={tdStyle}>
                    {getProblemTypeTranslation(report.problem_in)}
                  </TableRowColumn>
                  <TableRowColumn colSpan={1} style={tdStyle}>
                    <ActionSearch onClick={() => this.goToDetails(report)} style={{ color: '#6B7c93', height: '30px', width: '30px', cursor: 'pointer' }} />
                  </TableRowColumn>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default ProblemReportsTable;



// WEBPACK FOOTER //
// src/routes/ProblemReports/ProblemReportsTable.js